export const BROWSER_PAGE_SEO_TITLE_FALLBACK_TIMEOUT = 10_000 //ms

export const META_DESCRIPTION_NAME = 'description'
